module.exports = __webpack_public_path__ + "static/media/twilio_logo.e3954a6f.png";